module.exports = __webpack_public_path__ + "static/media/pano-polimento.14ce6f19.jpg";